const CALENDAR_TYPE = "text/calendar;charset=utf-8";

/** Long enough for WebKit, which starts a download after the click has returned. */
export const CALENDAR_URL_REVOKE_MS = 30_000;

export function calendarFile(filename: string, ics: string): File {
  return new File([ics], filename, { type: CALENDAR_TYPE });
}

/**
 * Saves an .ics in the browser. The link joins the document for the click, and its blob URL outlives
 * it: revoked at once, Safari and iOS fail the download with WebKitBlobResource error 1.
 */
export function downloadCalendarFile(filename: string, ics: string): void {
  const url = URL.createObjectURL(new Blob([ics], { type: CALENDAR_TYPE }));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), CALENDAR_URL_REVOKE_MS);
}
